// extracted by mini-css-extract-plugin
export default {"container":"header_container__AzWgZ","ownMargin":"header_ownMargin__w-wob","logo":"header_logo__wLirW"};